import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Consultas from "views/examples/consultas";
import Reportes from "views/examples/Reportes";
import TablaUsuarios from "views/examples/Usuario";
import Solicitudes from "views/examples/Solicitudes";
import AprobadorAbastecimiento from "views/examples/AprobadorAbastecimiento";
import AprobadorDirecto from "views/examples/AprobadorDirecto";
import AprobadorJuridico from "views/examples/AprobadorJuridico";
import RepresentanteLegal from "views/examples/RepresentanteLegal";
import CreaTipoContrato from "views/Crea/CreaTipoContrato";
import VariablesContrato from "views/Crea/VariablesContrato";
import Cookies from "universal-cookie";
import CreaAprobadorTecnico from "views/Crea/CreaAprobadorTecnico";
import VerAreas from "views/examples/VerAreas";
import SolicitudesPropias from "views/examples/SolicitudesPropias";
import ConsultarGlpi from "views/GLPI/ConsultarGlpi";
import AprobadorTecnico from "views/examples/AprobadorTecnico";
import Repositorio from "views/examples/Repostitorio";
import ConsultaAbastecimiento from "views/examples/ConusltaAbastecimiento";

const cookie = new Cookies();
const correo = cookie.get("correo");

// Codificar a Base64 y luego hacer seguro para URL
const correoBase64 = btoa(correo);
const correoSeguro = encodeURIComponent(correoBase64);

var routes = [
  {
    path: "/Solicitudes/:id",
    name: "Solicitudes",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <SolicitudesPropias />,
    layout: "/admin",
  },
  {
    path: "/SolicitudesAsignadas/" + correoSeguro,
    name: "Solicitudes Asignadas",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <Solicitudes />,
    layout: "/admin",
  },
  {
    path: "/Consultas",
    name: "Consultar Casos Abastecimiento",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <ConsultaAbastecimiento />,
    layout: "/admin",
  },
  {
    path: "/ConsultaGLPI",
    name: "Documentos GLPI",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <ConsultarGlpi />,
    layout: "/admin",
  },
  {
    path: "/Usuario",
    name: "Usuarios",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <TablaUsuarios />,
    layout: "/admin",
  },
  {
    path: "/AprobadorAbastecimiento",
    name: "Abastecimiento",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <AprobadorAbastecimiento />,
    layout: "/admin",
  },
  {
    path: "/Areas",
    name: "Áreas  ",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <VerAreas />,
    layout: "/admin",
  },
  {
    path: "/AprobadorTecnico",
    name: "Técnicos",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <AprobadorTecnico />,
    layout: "/admin",
  },

  {
    path: "/AprobadorJuridico",
    name: "Aprobador jurídico",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <AprobadorJuridico />,
    layout: "/admin",
  },
  {
    path: "/RepresentanteLegal",
    name: "Representante legal",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <RepresentanteLegal />,
    layout: "/admin",
  },

  {
    path: "/CreaTipoContrato",
    name: "Crear tipo contrato",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <VariablesContrato />,
    layout: "/admin",
  },

  {
    path: "/VariablesContrato",
    name: "Variables contrato  ",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <CreaTipoContrato />,
    layout: "/admin",
  },
  {
    path: "/Repositorio",
    name: "Repositorio  ",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <Repositorio />,
    layout: "/admin",
  },

  {
    path: "/login",

    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",

    component: <Register />,
    layout: "/auth",
  },
];
export default routes;
